var _style, _g, _path, _path2, _path3, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoodFridayGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85 85",
    style: {
      enableBackground: "new 0 0 85 85"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CCCCCC;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 42.5,
    cy: 42.5,
    r: 42.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-67.1-5.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-39.4-24.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-28.2-24.2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.6,31.3h-3.9v-0.9c1.3-0.3,2.2-0.8,2.9-1.6c0.9-1,1.2-2.5,1-4.2c-0.5-3.8-3.2-6.4-4.4-7.3 c-0.4-0.4-0.9-0.4-1.4-0.1c-0.2,0.1-4.2,2.8-4.5,7.5c-0.1,1.8,0.3,3.2,1.3,4.4c0.9,0.9,2,1.3,2.6,1.4v0.9h-3.9 c-1.2,0-2.2,1-2.2,2.2l0,32.6c0.1,1.2,1.1,2.1,2.2,2.1h10.1c1.2,0,2.2-1,2.2-2.2V33.4C49.8,32.2,48.8,31.3,47.6,31.3z M41.1,46.6 c1.4,0,2.7-1.2,2.7-2.7v-4.1c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v2c0,1.6,1.5,2.9,3.1,2.6L47.8,66L37.5,66V43.5 c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4V44C38.4,45.4,39.6,46.6,41.1,46.6z M43.7,28v-1.6c0-0.6-0.5-1.1-1.1-1.1s-1.1,0.5-1.1,1.1 V28c-0.3-0.1-0.7-0.3-1-0.6l0,0c-0.5-0.5-0.8-1.4-0.7-2.7c0.2-2.6,1.9-4.5,2.8-5.3c0.8,0.8,2.5,2.7,2.9,5.4c0.2,1.1,0,1.9-0.5,2.4 C44.6,27.7,44.1,27.9,43.7,28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.6,41.2H56.5c-0.7,0-1.2,0.6-1.2,1.2s0.6,1.2,1.2,1.2h10.1c0.7,0,1.2-0.6,1.2-1.2S67.3,41.2,66.6,41.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.5,41.2H18.4c-0.7,0-1.2,0.6-1.2,1.2s0.6,1.2,1.2,1.2h10.1c0.7,0,1.2-0.6,1.2-1.2S29.2,41.2,28.5,41.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.4,52.2c-0.5-0.5-1.3-0.5-1.8,0s-0.5,1.3,0,1.8l5,5c0.2,0.2,0.6,0.4,0.9,0.4s0.6-0.1,0.9-0.4 c0.5-0.5,0.5-1.3,0-1.8L57.4,52.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.6,52.2l-5,5.1c-0.5,0.5-0.5,1.3,0,1.8c0.2,0.2,0.6,0.4,0.9,0.4s0.6-0.1,0.9-0.4l5-5.1 c0.5-0.5,0.5-1.3,0-1.8S28.1,51.7,27.6,52.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.3,26.6c-0.5-0.5-1.3-0.5-1.8,0s-0.5,1.3,0,1.8l5,5c0.2,0.2,0.6,0.4,0.9,0.4s0.6-0.1,0.9-0.4 c0.5-0.5,0.5-1.3,0-1.8L24.3,26.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.5,33.8c0.3,0,0.6-0.1,0.9-0.4l5.5-5.5c0.5-0.5,0.5-1.3,0-1.8c-0.5-0.5-1.3-0.5-1.8,0l-5.5,5.5 c-0.5,0.5-0.5,1.3,0,1.8C55.9,33.6,56.2,33.8,56.5,33.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodFridayGrey);
export default __webpack_public_path__ + "static/media/GoodFridayGrey.a352676307e476b58ea7e24cf7e124c4.svg";
export { ForwardRef as ReactComponent };